import React, { useCallback } from "react";
import { FilterType } from "../../../api/services";
import { ToggleButtonGroup } from "@material-ui/lab";
import { ViewToggleButton } from "../../../components/ViewToggleButton";

type ActivityFilter = {
  label: string; // display
  type: FilterType | "ALL";
};

// Available filters: order --> display order
const ActivityFilters: ActivityFilter[] = [
  {
    label: "All",
    type: "ALL",
  },
  {
    label: "Wrap-up / Notes",
    type: "DemandNote",
  },
  {
    label: "Communication",
    type: "Communication",
  },
  {
    label: "Tickets",
    type: "Ticket",
  },
  {
    label: "Bills",
    type: "Bill",
  },
  {
    label: "Financial",
    type: "Financial",
  },
  {
    label: "Agreement",
    type: "Agreement",
  },
];

export const ActivityViewFilters: React.FC<{
  filter: FilterType | undefined;
  setFilter: (f: FilterType | undefined) => void;
}> = ({ filter, setFilter }) => {
  const handleChange = useCallback(
    (_event: any, value: FilterType | "ALL") => {
      if (value === "ALL") {
        setFilter(undefined);
      } else if (value !== null) {
        setFilter(value);
      }
      // Don't handle value = null that happens when clicking on a toggled button.
      // The user must click a different button to change the toggle state
    },
    [setFilter],
  );
  return (
    <ToggleButtonGroup
      exclusive
      value={filter || "ALL"}
      onChange={handleChange}
    >
      {ActivityFilters.map((f) => (
        <ViewToggleButton value={f.type} label={f.label} key={f.type} />
      ))}
    </ToggleButtonGroup>
  );
};
